module.exports = __webpack_public_path__ + "static/media/dp-logo-header-dark.c9521655.png";